import { FC } from 'react'
import { useRouter } from 'next/router'
import { ButtonBase, Zoom } from '@mui/material'
import CookieOutlinedIcon from '@mui/icons-material/CookieOutlined'
import { useConsentStore } from 'store/consentStore'
import { usePrizeDrawContextStore } from 'store/prizeDrawContextStore'
import { DESKTOP_QUERY, MOBILE_QUERY } from '../bottomNavStyles'

const BUTTON_BG = '#0F1E27'
const BUTTON_BORDER = '#1a2c38'
const ICON_COLOR_PRIZE_DRAW = '#36E0F6'
const ICON_COLOR_PREDICTOR = '#FFC107'

// Round button in the bottom-left that reopens the cookie banner once a choice has been made,
// alongside the footer's "Cookie Settings" link. Sits above the mobile bottom nav; drawers and
// bottom sheets (z-index 1200) cover it.
export const CookieSettingsButton: FC = () => {
  const hasChosen = useConsentStore((state) => state.consent !== null)
  const isBannerOpen = useConsentStore((state) => state.isBannerOpen)
  const openSettings = useConsentStore((state) => state.openSettings)
  const isShown = hasChosen && !isBannerOpen
  // Matches the header and profile drawer: the page's own context, else the URL.
  const { pathname } = useRouter()
  const isPrizeDrawContext = usePrizeDrawContextStore((state) => state.isPrizeDrawContext)
  const isPrizeDrawView = isPrizeDrawContext ?? pathname.includes('/prize-draw')

  return (
    <Zoom in={isShown} style={{ transitionDelay: isShown ? '300ms' : '0ms' }} unmountOnExit>
      <ButtonBase
        onClick={openSettings}
        aria-label="Cookie settings"
        title="Cookie settings"
        sx={{
          position: 'fixed',
          zIndex: 1100,
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          bgcolor: BUTTON_BG,
          border: `1px solid ${BUTTON_BORDER}`,
          color: isPrizeDrawView ? ICON_COLOR_PRIZE_DRAW : ICON_COLOR_PREDICTOR,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          [MOBILE_QUERY]: {
            left: '12px',
            bottom: 'calc(var(--bottom-nav-height, env(safe-area-inset-bottom, 0px)) + 12px)',
          },
          [DESKTOP_QUERY]: { left: '24px', bottom: '24px' },
        }}
      >
        <CookieOutlinedIcon sx={{ fontSize: '24px' }} />
      </ButtonBase>
    </Zoom>
  )
}
